export function defaultColumnVisibility<T extends string>(columns: Array<{ id: T }>): Record<T, boolean> {
	return Object.fromEntries(columns.map((column) => [column.id, true])) as Record<T, boolean>;
}

export function compareLocale(a: string, b: string, dir: "asc" | "desc"): number {
	const order = a.localeCompare(b, undefined, { numeric: true, sensitivity: "base" });
	return dir === "asc" ? order : -order;
}
